import { render, staticRenderFns } from "./HeroHeadlineElementSettings.vue?vue&type=template&id=632ce14c&scoped=true&"
import script from "./HeroHeadlineElementSettings.vue?vue&type=script&lang=ts&"
export * from "./HeroHeadlineElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632ce14c",
  null
  
)

export default component.exports